export interface IInterestMaster {
  id?: number;
  name?: string | null;
  value?: string | null;
}

export const defaultValue: Readonly<IInterestMaster> = {};
